import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { capitalizeFirstLetter } from '../../../utils';
import { useConfig } from '../../../context';
import SummaryItem from '../Summary/SummaryItem';
import Money from '../../../Money';
import { OrderPriceQueryQuery } from '@websky/graphql';

interface Props {
	prices: Omit<OrderPriceQueryQuery['OrderPrice']['priceToPay'], 'total'>;
}

const PriceParts: React.FC<Props> = ({ prices }) => {
	const { t } = useTranslation('PaymentForm');

	const {
		global: { showZeroCharges }
	} = useConfig();

	return (
		<>
			{Object.keys(prices)
				.filter(priceKey => {
					const amount = prices[priceKey]?.amount;

					if (showZeroCharges) {
						return priceKey !== 'charge' && amount !== undefined;
					}

					return amount > 0;
				})
				.map(priceKey => (
					<SummaryItem key={priceKey} price={<Money money={prices[priceKey]} />}>
						{t(capitalizeFirstLetter(priceKey))}:
					</SummaryItem>
				))}
		</>
	);
};

export default PriceParts;
